import isString from 'lodash/isString';
import padStart from 'lodash/padStart';

import moment from 'moment';

import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
} from 'react';
import styled from 'styled-components';

// import { stringify as stringifyQuery } from 'querystring';

import AntdModal from 'antd/lib/modal';
import AntdButton from 'antd/lib/button';

import Admin from 'hive-admin';
import FieldSortableList from 'hive-admin/src/components/FieldSortableList';

import tests from '../helpers/tests';

import Types from '../modules/types';

const {
  activityIsNotEdit,
} = tests;

const isCardNew = [
  'condition.testFieldValue',
  'new',
  '==',
  true,
];

const isCardNotNew = [
  'condition.not',
  isCardNew,
];

const CheckoutRedirectModalHTML = ({ className, ...props }) => (
  <AntdModal wrapClassName={className} {...props} />
);

const CheckoutRedirectModal = styled(CheckoutRedirectModalHTML)`
  .ant-modal {
    max-width: 1024px;
  }

  .ant-modal-content {
    position: relative;
    overflow: hidden;
    height: calc(100vh - 40px);
    border-radius: 20px;
    /* padding: 0 25px; */

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      padding: 0px;
      margin: 0px;
      /* height: calc(100% - 40px - 20px); */
      height: 100%;
      overflow: hidden;
      iframe {
        border: 0px;
      }
    }
  }
`;

const FieldCardsNewCardModal = ({
  card,
  reload,
  onCancel,
  // ...props
}) => {
  const iframeListener = useCallback(
    (event) => {
      // if (event.origin === window.location.origin) {
        try {
          const [name, data] = JSON.parse(event.data);
          // eslint-disable-next-line no-console
          console.log('message:', name, data);
          if (data && data.success) {
            Admin.showMessage(
              'Card added successfully.',
              'success',
              5,
            );
          } else {
            Admin.showMessage(
              'Error adding card, please try again',
              'error',
              5,
            );
          }
          reload();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('message error:', error, event.data);
          reload();
        }
      // }
    },
    [reload],
  );
  useEffect(
    () => {
      window.addEventListener('message', iframeListener);
      return () => {
        window.removeEventListener('message', iframeListener);
      };
    },
    [iframeListener],
  );
  if (!card) {
    return null;
  }
  return (
    <CheckoutRedirectModal
      visible={!!card.checkoutRedirect}
      title="Checkout Validation"
      footer={null}
      centered
      width="calc(100vw - 40px)"
      height="calc(100vh - 40px)"
      onCancel={onCancel}
    >
      {
        card.checkoutRedirect
        ? (
            <iframe
              title="Checkout Validation"
              width="100%"
              height="100%"
              // frameBorder={0}
              // scrolling="no"
              src={card.checkoutRedirect}
            />
          )
        : null
      }
    </CheckoutRedirectModal>
  );
};

const FieldCardsActions = styled.div`
  display: flex;
  gap: 10px;
`;

const FieldCardField = (props) => {
  // const { parentData, reload } = props;
  const [card, setCard] = useState(props.data);
  const addCardAction = useMemo(
    () => Admin.compileFromLibrary(['ActionWithRequest', {
      id: null,
      name: null,
      title: 'Add Card',
      renderAction: (actionProps, instance) => React.cloneElement(
        instance.renderAction(actionProps),
        { style: { marginBottom: '0px', width: '100%' } },
      ),
      processAction: async (actionProps) => {
        const data = {};
        const frames = await (
          actionProps
          .checkoutCardInputRef
          .current
          .getFrames()
        );
        if (!frames) {
          throw new Error('Cannot process cards at this moment');
        }
        if (!frames.cardholder) {
          frames.cardholder = {};
        }
        frames.cardholder.name = card.name;
        frames.cardholder.billingAddress = {
          addressLine1: card.addressLine1 || undefined,
          addressLine2: card.addressLine2 || undefined,
          city: card.city || undefined,
          country: card.country?.toUpperCase() || 'AE',
        };
        try {
          frames.enableSubmitForm();
          const checkoutResult = await frames.submitCard();
          data.token = checkoutResult.token;
          return await (
            actionProps
            .issueRequest(actionProps, {
              url: `stores/${
                actionProps?.match?.params?.id || 'me'
              }/add-card`,
              method: 'POST',
              data: JSON.stringify(data),
            })
            .then(response => {
              setCard({ ...response.data, new: true });
            })
          );
        } catch (error) {
          if (isString(error)) {
            // eslint-disable-next-line no-ex-assign
            error = new Error(error);
          }
          throw error;
        }
      },
    }]),
    [
      card?.name,
      card?.addressLine1,
      card?.addressLine2,
      card?.country,
      card?.city,
    ],
  );
  const removeCardAction = useMemo(
    () => Admin.compileFromLibrary(['ActionWithRequest', {
      id: null,
      name: null,
      title: 'Remove Card',
      type: 'danger',
      popconfirm: {
        title: (
          <>
            Are you sure? Your subscription will not be autorenewed
            <br />
            until you add another payment method.
          </>
        ),
      },
      block: true,
      style: { width: '100%' },
      ghost: true,
      renderAction: (actionProps, instance) => React.cloneElement(
        instance.renderAction(actionProps),
        { style: { marginBottom: '0px', width: '100%' } },
      ),
      getRequestConfig: (actionProps) => ({
        url: `stores/${
          actionProps?.match?.params?.id || 'me'
        }/remove-card`,
        method: 'POST',
      }),
      handleSuccess: (data, actionProps) => {
        actionProps.reload();
      },
    }]),
    [],
  );
  if (!card) {
    return null;
  }
  return (
    <>
      {
          card.checkoutRedirect
        ? (
            <FieldCardsNewCardModal
              {...props}
              onCancel={() => setCard(props.data)}
              card={card}
            />
          )
        : !card.new
        ? (
            card.id
            ? (
                <>
                  <FieldCardFieldPresentationOnlyWrapper>
                    <span>
                      <p>
                        {`${card.scheme}`}
                      </p>
                    </span>
                    <span>
                      <p>
                        {`**** **** **** ${card.last4}`}
                      </p>
                      <p>
                        {`${
                          padStart(`${card.expiryMonth}`.slice(-2), 2, '0')
                        }/${
                          padStart(`${card.expiryYear}`.slice(-2), 2, '0')
                        }`}
                      </p>
                    </span>
                  </FieldCardFieldPresentationOnlyWrapper>
                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      background: '#ddd',
                      marginTop: '15px',
                      marginBottom: '20px',
                    }}
                  />
                  <FieldCardsActions style={{ marginTop: '10px' }}>
                    <AntdButton
                      ghost
                      type="primary"
                      style={{ width: '100%' }}
                      data-action={null}
                      onClick={() => props.forms[0].setFieldsValue({
                        cards: [
                          props.generateNewItem(props),
                        ],
                      })}
                    >
                      Update Card
                    </AntdButton>
                    {removeCardAction.render(props)}
                  </FieldCardsActions>
                </>
              )
            : (
                <h2>Failed</h2>
              )
          )
        : (
            <FieldCardsActions>
              {addCardAction.render(props)}
              <AntdButton
                // ghost
                type="danger"
                style={{ width: '100%' }}
                onClick={() => {
                  const data = (
                    props.datas?.length
                    ? props.datas[0]
                    : props.data
                  );
                  props.forms[0].setFieldsValue({
                    cards: data?.cards ? [...data.cards] : [],
                  });
                }}
              >
                Cancel
              </AntdButton>
            </FieldCardsActions>
          )
      }
    </>
  );
};

const FieldCardFieldPresentationOnlyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -20px;
  padding-bottom: 20px;
  p {
    margin-bottom: 0px;
  }
  > span:nth-child(1) {
    text-align: left;
    font-weight: 600;
    font-size: 28px;
  }
  > span:nth-child(2) {
    display: block;
    text-align: right;
    p {
      text-align: right;
      font-family: ${({ theme }) => theme.monospaceFontStack};
    }
  }
`;

export const fieldCheckoutCardsTitle = ['FieldTitle', {
  textStyle: {
    width: '100%',
  },
  getTitle: (_, props) => {
    if (!props.data?._id) {
      return null;
    }
    const dateMoment = moment();
    const {
      getCheckoutComTransactionUrlBasedOnStoreId,
    } = Types.getSystemCountry(props.data.systemCountry);
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        <span>
          Card
        </span>
        {
          (props.data?._id && props.viewer?.role === 'ADMIN')
          ? (
              <>
                &nbsp;
                <a
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    marginBottom: '10px',
                  }}
                  href={getCheckoutComTransactionUrlBasedOnStoreId(
                    props.data._id,
                    {
                      v1: {
                        query: {
                          search: props.data?._id,
                          sortColumn: 'timestamp',
                          sortOrder: 'desc',
                          pageSize: 25,
                          startIndex: 0,
                        },
                      },
                      v2: {
                        query: {
                          customer: `${props.data?._id}@id.store.packman.app`,
                          date: `${
                            dateMoment
                            .clone()
                            .subtract(6, 'month')
                            .format('YYYYMMDD')
                          }..${
                            dateMoment
                            .format('YYYYMMDD')
                          }`,
                        },
                      },
                    },
                  )}
                >
                  <AntdButton>
                    Open Payments
                  </AntdButton>
                </a>
              </>
            )
          : null
        }
      </div>
    );
  },
}];

// eslint-disable-next-line import/prefer-default-export
export const fieldCheckoutCards = ['FieldSortableList', {
  name: 'cards',
  label: null,
  addButtonLabel: 'Add Card',
  maxCount: 1,
  supportRemove: false,
  // getSortableItemWrapperStyle: true,
  // getSortableListItemWrapperStyle: (value, props, self) => ({
  //   maxWidth: '400px',
  //   marginLeft: 'auto',
  //   marginRight: 'auto',
  // }),
  // eslint-disable-next-line no-unused-vars
  generateNewItem: (props, field) => {
    const data = props.datas?.length ? props.datas[0] : props.data;
    return {
      new: true,
      name: props.viewer.name || '',
      country: data?.address?.country,
      city: data?.address?.city,
      addressLine1: data?.address?.line1,
      addressLine2: data?.address?.line2,
    };
  },
  renderAddButton: (props, field, key, extras) => {
    const button = FieldSortableList.config.renderAddButton(
      props, field, key, extras,
    );
    return React.cloneElement(button, { style: { width: '100%' } });
  },
  shouldRenderPlaceholder: true,
  placeholderContent: (
    'Add Credit / Debit Card to pay for your Packman subscription online.'
  ),
  fields: [
    ['FieldHidden', {
      name: 'new',
      initialValue: false,
    }],
    ['FieldTitle', {
      title: 'New Card',
      wrapperStyle: { paddingTop: '0px' },
      skip: [isCardNotNew],
    }],
    ['FieldText', {
      name: 'name',
      label: null,
      prefix: 'Full Name:',
      rules: [['validation.isRequired']],
      skip: [isCardNotNew],
    }],
    ['FieldSelect', {
      name: 'country',
      label: null,
      prefix: 'Country:',
      choices: Types.COUNTRIES.map(({ name, iso3a2 }) => ({
        label: name,
        value: iso3a2,
      })),
      rules: [['validation.isRequired']],
      col: { span: 12 },
      skip: [isCardNotNew],
    }],
    ['FieldText', {
      name: 'city',
      label: null,
      prefix: 'City:',
      col: { span: 12 },
      skip: [isCardNotNew],
    }],
    ['FieldText', {
      name: 'addressLine1',
      label: null,
      prefix: 'Address Line 1:',
      skip: [isCardNotNew],
    }],
    ['FieldText', {
      name: 'addressLine2',
      label: null,
      prefix: 'Address Line 2:',
      skip: [isCardNotNew],
    }],
    ['FieldCheckoutCardInput', {
      name: 'frames',
      checkoutPublicKey: (props) => {
        const {
          checkoutComChannel,
          getCheckoutComVersionBasedOnStoreId,
        } = Types.getSystemCountry(props.parentData.systemCountry);
        return process.env[`REACT_APP_CHECKOUT_${
          getCheckoutComVersionBasedOnStoreId(props.parentData._id)
          .toUpperCase()
        }_PUBLIC_KEY_${
          checkoutComChannel.toUpperCase()
        }`];
      },
      label: null,
      style: {
        marginTop: '10px',
        marginBottom: '12px',
      },
      skip: [isCardNotNew],
    }],
    // ['FieldReact', {
    //   name: 'submitCard',
    //   label: null,
    //   renderContent: (props) => {
    //     console.log(props.data);
    //     const card = props.data;
    //   },
    //   skip: [isCardNotNew],
    // }],
    ['FieldReact', {
      label: null,
      virtual: [() => true],
      renderContent: props => (
        <FieldCardField {...props} />
      ),
    }],
  ],
  virtual: [
    () => true,
  ],
  skip: [
    activityIsNotEdit,
    // userIsNotCustomer,
  ],
}];
